import { BrandLogo } from '@giyus/ui';
import type { ReactNode } from 'react';

export interface AuthLayoutProps {
  readonly overline: string;
  readonly statement: readonly string[];
  readonly description: string;
  readonly legalName: string;
  readonly children: ReactNode;
}

/** Portal 1a entry composition; copy and authentication behavior belong to the caller. */
export function AuthLayout({
  overline,
  statement,
  description,
  legalName,
  children,
}: AuthLayoutProps) {
  return (
    <div className="grid min-h-svh bg-surface md:grid-cols-2">
      <aside className="relative flex min-h-72 flex-col justify-between gap-12 overflow-hidden bg-brand-panel px-6 py-8 text-brand-panel-foreground md:min-h-svh md:px-14 md:py-12">
        <BrandLogo
          symbol
          className="pointer-events-none absolute -right-30 -bottom-35 size-140 opacity-[0.08]"
        />
        <BrandLogo label="GIYUS" className="relative h-10 w-auto self-start" />
        <div className="relative flex max-w-105 flex-col gap-3.5">
          <p className="border-l-2 border-brand pl-2.5 text-caption font-semibold tracking-[0.18em] text-brand-panel-accent uppercase">
            {overline}
          </p>
          <p className="text-brand-statement font-semibold tracking-[-0.04em]">
            {statement.map((line) => (
              <span className="block" key={line}>
                {line}
              </span>
            ))}
          </p>
          <p className="text-body leading-relaxed text-brand-panel-muted">{description}</p>
        </div>
        <p className="relative text-caption text-brand-panel-muted">{legalName}</p>
      </aside>
      <div className="flex min-w-0 items-center justify-center px-6 py-10 md:p-12">
        <div className="flex w-full max-w-90 flex-col gap-[22px]">{children}</div>
      </div>
    </div>
  );
}
